import { Metadata } from '@metaplex-foundation/mpl-token-metadata'
import { NATIVE_MINT } from '@solana/spl-token'
import { PublicKey } from '@solana/web3.js'
import { useAsync } from 'react-async-hook'
import { AnchorProvider } from '@coral-xyz/anchor'
import { useSolana } from '@dewicats/connect-button'
import { getHeliusAsset } from '@utils/solanaUtils'

const USDC = new PublicKey('EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v')
export function useMetaplexMetadata(mint: PublicKey | undefined): {
  loading: boolean
  metadata: Metadata | undefined
  image: string | undefined
  symbol: string | undefined
  name: string | undefined
} {
  const { anchorProvider } = useSolana()

  const { result: json, loading: jsonLoading } = useAsync(
    async (
      provider: AnchorProvider | undefined,
      tokenMint: PublicKey | undefined,
    ) => {
      if (!provider?.connection || !tokenMint) return
      const cache = await fetch(`/api/cache?cacheId=${tokenMint.toBase58()}`)
      const data = await cache.json()
      if (data?.content) {
        return data
      }

      const asset = await getHeliusAsset(provider, tokenMint)

      // Cache the asset
      await fetch(`/api/cache`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          cacheId: tokenMint.toBase58(),
          data: asset,
        }),
      })

      return asset
    },
    [anchorProvider, mint],
  )

  if (mint?.equals(NATIVE_MINT)) {
    return {
      metadata: undefined,
      loading: false,
      symbol: 'SOL',
      name: 'SOL',
      image:
        'https://raw.githubusercontent.com/solana-labs/token-list/main/assets/mainnet/So11111111111111111111111111111111111111112/logo.png',
    }
  }

  if (mint?.equals(USDC)) {
    return {
      metadata: undefined,
      image: '',
      loading: false,
      symbol: 'USDC',
      name: 'USDC',
    }
  }

  if (json?.content?.metadata?.symbol === 'WAYRU') {
    return {
      loading: jsonLoading,
      image: 'https://www.dewicats.xyz/assets/wayru.png',
      symbol: json?.content?.metadata?.symbol,
      name: json?.content?.metadata?.name,
      metadata: json?.content?.metadata,
    }
  }

  return {
    loading: jsonLoading,
    image: json?.content?.files?.[0]?.cdn_uri,
    symbol: json?.content?.metadata?.symbol,
    name: json?.content?.metadata?.name,
    metadata: json?.content?.metadata,
  }
}
